import { Major, CareerPath } from '@backrs_ui/common-ui';

import { MajorDetailContent } from './MajorDetailContent';

type MajorPageProps = Readonly<{
  major: Major;
  careerPaths: CareerPath[];
}>;

export const MajorPage = ({ major, careerPaths }: MajorPageProps) => {
  return <MajorDetailContent major={major} careerPaths={careerPaths} />;
};
